var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detailInfo)?_c('div',{staticClass:"swipe-wrapper ui-common-swiper"},[(_vm.detailInfo.pgoods_image)?_c('img',{attrs:{"src":_vm.detailInfo.pgoods_image},on:{"click":function($event){return _vm.setPopupVisible()}}}):_c('img',{staticClass:"product-img",attrs:{"src":require("../../../../assets/image/home/default_image_banner.png")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }